<template>
  <img src="@/assets/Z-Logo.png" alt="Z Energy Logo" />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_responsive.scss';
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/_mixins.scss';
</style>
